import script from "./overlay-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./overlay-content.vue?vue&type=script&setup=true&lang=ts"

import "./overlay-content.vue?vue&type=style&index=0&id=34eec6a4&lang=scss"

const __exports__ = script;

export default __exports__